module.exports = __webpack_public_path__ + "img/ivywaychina_QR.fbd0c6a5.webp";